var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#minus';
                    var viewUrl = 'svg/icons.svg#view-minus';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };